const topbar = {
    docs: 'Dokumentacja',
    help: 'Pomoc',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
